export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Are these complete classes or just pose lists?',
    answer:
      'Complete classes. Each one includes the intention, duration and level, centering, warm-up, main sequence, cooldown, savasana, cues and modifications.',
  },
  {
    question: 'Is this for new or experienced instructors?',
    answer:
      'Both. New teachers get a professional structure to teach from. Experienced teachers skip the planning work they already know how to do.',
  },
  {
    question: 'Can I adapt the classes to my students?',
    answer:
      'Yes — every plan includes modification options so you can adjust pacing, props and intensity for the group in front of you.',
  },
  {
    question: 'How do I receive the material?',
    answer:
      'Digitally, right after purchase. Read all 6 volumes and the 5 bonus guides on your phone, tablet or laptop, or print them.',
  },
  {
    question: 'Is this a subscription?',
    answer: 'No. One-time purchase of USD $27. No monthly fee, no recurring charge.',
  },
]
